import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button } from 'components/Base';
import Icons from 'components/Icons';
import Router from 'components/Router/Router';
import { formatCurrency } from 'utils';

const { useHistory } = Router;

const useStyles = makeStyles({
  barContainer: {
    width: 'calc(100vw - 18rem)',
    height: '69px',
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
    padding: '0 2.625rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid #eaeaea',
    marginLeft: '18rem'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  },
  arrow: {
    width: '1rem'
  },
  info: {
    display: 'flex'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '2rem'
  },
  title: {
    fontWeight: 700
  },
  value: {
    fontWeight: 400
  }
});

interface Props {
  portfolio: string;
  totalInitial: number;
  totalOngoing: number;
}

const Footer = ({ portfolio, totalInitial, totalOngoing }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.barContainer}>
      <div className={classes.info}>
        <div className={classes.textContainer}>
          <span className={classes.title}>Total initial adviser charges</span>
          <span className={classes.value}>
            {formatCurrency(totalInitial || 0)}
          </span>
        </div>

        <div className={classes.textContainer}>
          <span className={classes.title}>Total ongoing adviser charges</span>
          <span className={classes.value}>
            {formatCurrency(totalOngoing || 0)} in year 1
          </span>
        </div>
      </div>
      <div className={classes.buttonContainer}>
        <Button
          endIcon={<Icons.RightArrow className={classes.arrow} />}
          key="Investment policy summary button"
          onClick={() => history.push(`/${portfolio}/ips`)}
          type="button"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Footer;
